// TODO: (ED-16187) Somehow this is breaking storybook if import directly from `styles/token`. Will revisit.
// eslint-disable-next-line custom/consolidate-token-imports
import { BLACK_ALPHA_0, BLACK_ALPHA_001, BLACK_ALPHA_002, BLACK_ALPHA_003 } from 'styles/tokens/color';
// eslint-disable-next-line custom/consolidate-token-imports
import { SPACE_0, SPACE_050, SPACE_100, SPACE_200, SPACE_300 } from 'styles/tokens/space';

/**
 * Subtle box shadow for minimal elevation (1px bottom border effect)
 */
export const BOX_SHADOW_100 = `${SPACE_0} 1px ${SPACE_0} ${SPACE_0} ${BLACK_ALPHA_0}`;
/**
 * Box shadow for primary/solid buttons with inset bottom + elevation
 */
export const BOX_SHADOW_300 = `${SPACE_0} -1px ${SPACE_0} ${SPACE_0} ${BLACK_ALPHA_001} inset, ${SPACE_0} ${SPACE_050} ${SPACE_100} ${SPACE_0} ${BLACK_ALPHA_001}`;
/**
 * Medium box shadow for elevated components (cards, modals, dropdowns)
 */
export const BOX_SHADOW_400 = `${SPACE_0} ${SPACE_0} 1px ${SPACE_0} ${BLACK_ALPHA_003}, ${SPACE_0} ${SPACE_200} ${SPACE_300} ${SPACE_0} ${BLACK_ALPHA_002}`;
